import React from 'react';

import ListItem from 'components/ListItem';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { useSelector } from 'react-redux';
import { makeSelectFertilizerProductValue } from 'services/fertilizerProducts/selectors';
import { AppState } from 'services/types';

interface OwnProps {
    productId: FertilizerProductId;
}

export type Props = OwnProps;

export default function FertilizerEventNameListItem(
    props: Props
): React.ReactElement {
    const name = useSelector((state: AppState) =>
        makeSelectFertilizerProductValue('name')(state, props)
    );

    return <ListItem value={name} description="Name" />;
}
